import React from "react";
import tripRequestLogo from "../../../assets/images/trip_request_icon.svg";
import { Link } from "react-router-dom";
import ROUTE_PATHS from "../../../utils/routePaths";
import CommonHeader from "../../../components/elements/CommonHeader";
import {
  clearHistoricFiltersStorage,
  clearHistoricSearchStorage,
} from "../../../utils/searchStorage";

const clearHistoricStorage = () => {
  clearHistoricSearchStorage();
  clearHistoricFiltersStorage();
};
const HistoricTripsDetailsHeader = ({ currentPage }) => {
  return (
    <CommonHeader
      centerLogoSrc={tripRequestLogo}
      headerText="Historic Trips"
      backContent={
        <div className="navigation-header">
          <Link
            to={ROUTE_PATHS.TRIP_REQUEST_PAGE}
            state={{ currentPage }}
            className="navigation-header-link"
            onClick={clearHistoricStorage}
          >
            Home/
          </Link>
          <Link
            to={ROUTE_PATHS.HISTORIC_TRIPS_PAGE}
            state={{ currentPage }}
            className="navigation-header-link"
          >
            Historic Trips/
          </Link>
          Trip
        </div>
      }
    />
  );
};

export default HistoricTripsDetailsHeader;
